import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { MiFormComponent } from 'app/modules/shared/components/mi-form/mi-form.component';
import { AttributeData } from '../../models/attribute.models';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { Country } from 'app/modules/shared/models/country';
import { AppSettings } from 'app/modules/shared/app.settings';
import { Language } from 'app/modules/shared/models/language';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { EntityResponse } from 'app/modules/shared/models/entityResponse.models';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { CommonModule, JsonPipe } from '@angular/common';
import { EntityList } from '../../models/entity.models';
import * as _ from 'lodash';
import { ListResponse } from '../../models/listResponse.models';
import { AppIcons } from 'app/modules/shared/app.icons';
import { from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { PatientSelectionDialogComponent } from './patient-selection/patient-selection-dialog.component';
import { TooltipModule } from 'primeng/tooltip';
import { MessageModule } from 'primeng/message';
@Component({
  selector: 'app-add-order',
  standalone: true,
  imports: [
    BreadcrumbModule,
    TabViewModule,
    MiFormComponent,
    DialogModule,
    ButtonModule,
    TranslateModule,
    AccessProviderDirective,
    DropdownModule,
    FormsModule,
    InputTextModule,
    InputNumberModule,
    AutoCompleteModule,
    CommonModule,
    ButtonModule,
    JsonPipe,
    PatientSelectionDialogComponent,
    TooltipModule,
    MessageModule,
  ],
  templateUrl: './add-order.component.html',
  styleUrl: './add-order.component.scss'
})
export class AddOrderComponent implements OnInit {
  @ViewChild(MiFormComponent) miFormComponent: MiFormComponent;
  miIcons = AppIcons;
  activeIndex: number = 0;
  data: AttributeData;
  orderAttributeData: any;
  routePath: MenuItem[] = [];
  attributeLabels = {};
  moduleName: string;
  country: Country;
  language: Language;
  relation: string = "oneToOne";
  cols: any = [];
  orderAttributeLength;
  orderId: string;
  orderIdForDocument: string;
  orderDocumentId;
  driverRelation: any;
  attributeValues = [];
  nextBtnLabel;
  previousBtnLabel;
  label: string;
  initialLabel: string = this.cs.getLabel("lbl_details");
  saveOrderBtnLabel: string;
  isFirstTabSaved: boolean = false;
  isNew: boolean = true;
  prefixToAttachForButtonIdToUniquelyIdentifyButton = AppSettings.BUTTON_PREFIX
  tabCode;
  tabIndex;
  protocolAttributeData: any;
  orderProductAttributeData: any;
  protocolEntityId: string;
  isAllowToPlaceOrder: boolean = true;


  items: any[] = [];

  selectedItem: any;
  filteredItems: any[] = [];

  entityProtocolData = {
    viewCode: '',
    countryCode: '',
    forTenantCode: '',
    searchText: '',
    actionStatus: '',
    deleted: '',
    eventCode: '',
    filters: [],
    advanceFilters: []
  };

  entityProductData: EntityList = {
    limit: AppSettings.AUTOCOMPLETE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: "",
    actionStatus: ''
  };



  products: any[] = [];
  selectedProtocol = null;
  showPatientDialog: boolean = false;
  selectedProductIndex: number = -1;
  selectedPatientsForDialog: any[] = [];
  showConfirmDialog: boolean = false;
  confirmProducts: any[] = [];
  quantityErrors: { [key: number]: string } = {};
  isPatientManagmentOn: boolean = false;

  get canPlaceOrder(): boolean {
    return this.products.some(product => product.qty && product.qty > 0) &&
      Object.keys(this.quantityErrors).length === 0;
  }

  constructor(
    private orderService: EntityService,
    private cs: CommonBindingDataService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private configService: ConfigService
  ) { }

  ngOnInit() {
    this.retrieveOrderId();
    this.initializeLabels();
    this.initializeOrderService();
    this.getInitialData();
    this.loadOrderData();
    this.setRoutePath();
    this.getProtocolfilterView()
    this.isFirstTabSaved = false;
    this.activeIndex = 0;
    this.isPatientManagmentOn = false;
  }

  getInitialData() {
    this.entityProtocolData.forTenantCode = this.configService.getForTenantCode();
    this.entityProtocolData.countryCode = this.country[0].countryCode;
    this.entityProtocolData.viewCode = 'AUTOCOMPLETE_VIEW'

    this.fetchFromAPI(this.entityProtocolData.viewCode, '');
  }

  getProtocolfilterView() {
    this.orderService.getAttributeDefinition(AppSettings.ENTITY_CODE.PROTOCOL_PRODUCT, AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW).subscribe(
      (data: any) => {
        this.protocolAttributeData = this.cs.getColumns(data);
        this.protocolAttributeData = _.sortBy(this.protocolAttributeData, 'attributeIndex');
        this.entityProductData.filters = [{
          attributeId: this.protocolAttributeData.find(field => field.attributeCode === 'protocol_entity_id')?.attributeId,
          attributeValue: ""
        }, {
          attributeId: this.protocolAttributeData.find(field => field.attributeCode === 'product_status')?.attributeId,
          attributeValue: 'Active'
        }]
      }
    );
  }

  setOptions(items: any) {
    this.items = items.map(item => ({
      name: item.product_name || item.name,
      id: item.id
    }));
  }

  onSelectItem() {
    this.protocolEntityId = this.selectedItem.id;
    this.orderService.getProtocolUser(this.protocolEntityId).subscribe((res: any) => {
      this.isAllowToPlaceOrder = res?.canOrder || false;
      this.isPatientManagmentOn = res?.canManagePatient || false;
    });
    this.getProducts();
  }

  getProducts() {
    this.entityProductData.forTenantCode = this.configService.getForTenantCode();
    this.entityProductData.countryCode = this.country[0].countryCode;
    this.entityProductData.filters[0].attributeValue = this.selectedItem.id;
    this.orderService.searchEntity(AppSettings.ENTITY_CODE.PROTOCOL_PRODUCT, this.entityProductData, false).subscribe((res: ListResponse) => {
      if (!res?.data?.length) {
        this.products = [];
        return;
      }
      this.products = res.data.map(data => ({
        id: data.id,
        ...(data.values || {})
      }));
    });
  }

  filterItems(event: AutoCompleteCompleteEvent) {
    const query = event.query;
    this.entityProtocolData.searchText = query;
    this.fetchFromAPI(this.entityProtocolData.viewCode, query);
  }

  fetchFromAPI(viewCode: string, search: string) {
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    const requestBody = {
      viewCode,
      countryCode: this.country[0].countryCode,
      forTenantCode: this.configService.getForTenantCode(),
      searchText: search,
      actionStatus: "RUNNING",
      deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
      filters: [],
      advanceFilters: []
    }

    if (!requestBody.filters) {
      requestBody.filters = [];
    }

    this.orderService.autoComplete(AppSettings.ENTITY_CODE.PROTOCOL, requestBody).subscribe(res => {
      this.items = this.cs.getTableData(res) || [];
      this.filteredItems = this.items.map(item => ({
        name: item.protocol_name,
        id: item.id
      }));
    });
  }

  setFormValue(value: { name: string, id: string }) {
    this.selectedItem = value;
  }

  private initializeLabels() {
    this.nextBtnLabel = this.cs.getLabel("lbl_next");
    this.previousBtnLabel = this.cs.getLabel("lbl_previous");
    this.saveOrderBtnLabel = this.orderId ?
      this.cs.getLabel("order.lbl_update_order") :
      this.cs.getLabel("order.add_order");
  }

  private retrieveOrderId() {
    this.orderId = this.route.snapshot.paramMap.get("id");
    if (this.orderId) {
      this.orderIdForDocument = this.orderId;
    }
  }

  private initializeOrderService() {
    this.moduleName = AppSettings.ENTITY_TYPE.ORDER;
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.orderService.setRelatedData([]);
  }

  private loadOrderData() {
    if (this.orderId) {
      this.orderService.getEntity(this.orderId, AppSettings.ENTITY_CODE.ORDER, AppSettings.VIEW_CODE.ADD_EDIT_VIEW).subscribe(
        (data: any) => {
          this.processOrderResponse(data);
        },
        (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
        }
      );
    } else {
      this.getAttributes();
    }
  }

  getAttributes() {
    const data = {
      "forTenantCode": "taks",
      "viewCode": "ADD_EDIT_VIEW",
      "relatedEntities": {
        "protocol": "PROTOCOL_BUDGET_UPDATE_VIEW",
        "order_product": "ADD_EDIT_VIEW"
      }
    };

    this.orderService.getAttributeDefinationWithProtocol(AppSettings.ENTITY_CODE.ORDER, AppSettings.VIEW_CODE.PROTOCOL_BUDGET_VIEW, data).subscribe(
      (data: any) => {
        const orderProduct = data.relatedAttributes.filter(item => item.entityCode === AppSettings.ENTITY_CODE.ORDER_PRODUCT)[0];
        this.orderProductAttributeData = this.cs.getOrganizedAttribute(orderProduct);
      }
    );
    this.orderService.getAttributeDefinition(AppSettings.ENTITY_CODE.ORDER, AppSettings.VIEW_CODE.ADD_EDIT_VIEW).subscribe(
      (data: any) => {
        this.setOrderView(data);
      }
    );
  }

  processOrderResponse(data: any) {
    this.attributeValues = this.cs.getOrgAttributeValues(data);
    this.getAttributes();
  }


  setOrderView(res) {
    this.orderAttributeData = res;
    this.attributeLabels = this.cs.getAttributeLabels(res);
    this.orderAttributeData = this.cs.getOrganizedAttribute(res);

    this.orderAttributeData.tabs = this.orderAttributeData.tabs.map(tab => ({
      ...tab,
      groups: tab.groups.map(group => ({
        ...group,
        fields: group.fields.filter(field => {
          if (field.attributeCode === 'protocol_id') {
            field.moduleName = AppSettings.ENTITY_CODE.PROTOCOL;
            field.actionStatus = 'RUNNING';
            return true;
          }
          return true;
        })
      }))
    }));
  }

  private setDateFieldValidation(tabCode, groupCode, attributeCode, isMax) {
    const attribute = this.orderAttributeData.tabs
      .find(tab => tab.tabCode === tabCode)
      ?.groups.find(group => group.code === groupCode)
      ?.fields.find(field => field.attributeCode === attributeCode);

    if (attribute) {
      attribute.validation.max = isMax ? new Date().toISOString() : null;
    }
  }


  onTabChange(event) {
    this.activeIndex = event.index;
  }

  setRoutePath() {
    this.routePath = [
      {
        label: this.cs.getLabel('order.lbl_new_order'),
        routerLink: '/app/orders',
        icon: 'pi pi-arrow-left',
        iconStyle: { 'font-weight': 'bold', 'margin-right': '10px' },
        command: () => {
          this.router.navigate['app/orders'];
        }
      },
      {
        label: this.cs.getLabel("order.lbl_details"),
        routerLink: `../${this.orderId}`,
        styleClass: 'breadcrumb-child forward-slash breadcrumb-text',
        style: { 'display': 'flex', 'top': '2px', 'position': 'relative' }
      },
    ];
  }


  onSelectProduct() {
    // Product selection handler
  }

  placeOrder() {
    if (!this.selectedItem) {
      this.messageService.add({
        key: 'tst',
        severity: 'error',
        summary: 'Error',
        detail: this.cs.getLabel('order.lbl_please_select_protocol')
      });
      return;
    }

    if (Object.keys(this.quantityErrors).length > 0) {
      this.messageService.add({
        key: 'tst',
        severity: 'error',
        summary: 'Error',
        detail: 'Please fix quantity validation errors before placing order'
      });
      return;
    }

    if (!this.canPlaceOrder) {
      this.messageService.add({
        key: 'tst',
        severity: 'error',
        summary: 'Error',
        detail: this.cs.getLabel('order.lbl_please_add_qty')
      });
      return;
    }
    this.confirmProducts = this.products.filter(product => product.qty > 0);
    this.showConfirmDialog = true;
  }

  onConfirmOrder() {
    this.showConfirmDialog = false;
    this.actuallyPlaceOrder();
  }

  onCancelOrder() {
    this.showConfirmDialog = false;
  }

  onConfirmCancel() {
    this.showConfirmDialog = false;
  }

  private actuallyPlaceOrder() {
    const productEntityIds = [];
    const protocolId = this.orderAttributeData?.tabs[0]?.groups[0]?.fields?.find(
      element => element.attributeCode === 'protocol_id')?.attributeId;
    const productAttributeId = this.orderAttributeData.tabs[0]?.groups[0]?.fields.find(item => item.attributeCode === 'order_product_ids')?.attributeId;

    const orderEntityData = {
      forTenantCode: this.configService.getForTenantCode(),
      entityCode: AppSettings.ENTITY_CODE.ORDER,
      countryCode: this.country[0].countryCode,
      languageCode: this.language?.[0]?.langCode || 'en',
      data: [],
    }
    orderEntityData.data = [{
      'attributeId': protocolId,
      'attributeValue': this.selectedItem.id
    }, {
      'attributeId': productAttributeId,
      'attributeValue': productEntityIds
    }];

    const protocolProductAttributeId = this.orderProductAttributeData.tabs[0]?.groups[0]?.fields.find(item => item.attributeCode === 'protocol_product_id')?.attributeId;
    const productQtyAttributeId = this.orderProductAttributeData.tabs[0]?.groups[0]?.fields.find(item => item.attributeCode === 'quantity')?.attributeId;
    const productPatientAttributeId = this.orderProductAttributeData.tabs[0]?.groups[0]?.fields.find(item => item.attributeCode === 'patient_ids')?.attributeId;

    if (this.products.length > 0) {
      const chain$ = this.products.reduce((obs$, product) => {
        return obs$.pipe(
          switchMap(() => {
            if (!product.qty) {
              return of(null);
            }

            const productData = {
              forTenantCode: this.configService.getForTenantCode(),
              entityCode: AppSettings.ENTITY_CODE.ORDER_PRODUCT,
              countryCode: this.country[0].countryCode,
              languageCode: this.language?.[0]?.langCode || 'en',
              data: [],
              relationshipData: []
            };
            productData.data = [{
              'attributeId': protocolProductAttributeId,
              'attributeValue': product.id
            }, {
              'attributeId': productQtyAttributeId,
              'attributeValue': product.qty
            }];
            if (product.patient_ids && product.patient_ids.length > 0) {
              productData.data.push({
                'attributeId': productPatientAttributeId,
                'attributeValue': product.patient_ids
              });
            }
            const entitiesData = {
              countryCode: this.country[0].countryCode,
              tenantCode: this.configService.getForTenantCode(),
            };
            return this.orderService
              .createEntities(AppSettings.ENTITY_CODE.ORDER_PRODUCT, entitiesData)
              .pipe(
                switchMap((res: EntityResponse) => {
                  productEntityIds.push(res.entityId);
                  return this.orderService.saveAttributeData(productData.entityCode, res.entityId, productData);
                })
              );
          })
        );
      }, from([null]));
      chain$.subscribe({
        next: () => {
          this.saveOrder(orderEntityData, productEntityIds);
        },
        error: () => {
          // handle error if needed
        }
      });
    } else {
      this.saveOrder(orderEntityData, productEntityIds);
    }
  }

  saveOrder(orderEntityData, productEntityIds) {
    const orderProductRelationshipConfigId = _.find(this.orderAttributeData?.relations, { otherEntityCode: AppSettings.ENTITY_CODE.ORDER_PRODUCT, relation: "oneToMany" }).entityRelationshipConfigId;
    const protocolRelationshipConfigId = _.find(this.orderAttributeData?.relations, { otherEntityCode: AppSettings.ENTITY_CODE.PROTOCOL, relation: "oneToOne" }).entityRelationshipConfigId;
    const orderPayload = orderEntityData;

    orderPayload.relationshipData = [
      {
        "entityRelationshipConfigId": protocolRelationshipConfigId,
        "otherEntityId": this.selectedItem.id
      },
    ];

    orderPayload.relationshipData.push(...productEntityIds.map(id => ({
      "entityRelationshipConfigId": orderProductRelationshipConfigId,
      "otherEntityId": id
    })));

    const entitiesData = {
      countryCode: this.country[0].countryCode,
      tenantCode: this.configService.getForTenantCode(),
    };
    this.orderService.createEntities(AppSettings.ENTITY_CODE.ORDER, entitiesData).subscribe((res: EntityResponse) => {
      this.orderService.saveAttributeData(AppSettings.ENTITY_CODE.ORDER, res.entityId, orderPayload).subscribe(() => {
        this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: this.cs.getLabel('order.lbl_order_added_successfully') });
        this.router.navigate(["app/orders"]);
      });
    });

  }




  onSaveOrder(event) {

    const productData = {
      forTenantCode: this.configService.getForTenantCode(),
      entityCode: this.moduleName,
      countryCode: this.country[0].countryCode,
      languageCode: this.language?.[0]?.langCode || 'en',
      data: [],
      relationshipData: []
    };

    const pData = event;
    for (const [key, value] of Object.entries(pData)) {
      const attributeValue = <any>value;
      const obj = typeof attributeValue;
      if (obj == "object") {
        if (attributeValue?.length > 0) {
          productData.data.push({
            attributeCode: key,
            attributeValue,
          });
        }
      } else {
        productData.data.push({
          attributeCode: key,
          attributeValue,
        });

      }
    }

    const entitiesData = {
      countryCode: this.country[0].countryCode,
      tenantCode: this.configService.getForTenantCode(),
    };

    if (!this.orderId) {
      this.orderService
        .createEntities(this.moduleName, entitiesData)
        .subscribe((res: EntityResponse) => {
          this.orderId = res.entityId;
          if (this.orderId) {
            this.orderIdForDocument = this.orderId;
          }
          this.saveOrderData(productData, true);
        },
        );

    } else {
      this.saveOrderData(productData, false);
    }
  }

  saveOrderData(orderData, isNew: boolean) {
    this.isNew = isNew;
    orderData.data = this.cs.mapAttributeIds(orderData.data, this.orderAttributeData.tabs)
    this.orderService
      .saveAttributeData(orderData.entityCode, this.orderId, orderData).subscribe({
        next: () => {
          const currentRoute = this.router.url;
          if (currentRoute === AppSettings.ADD_VEHICLE_ROUTE) {
            this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: this.cs.getLabel('product.lbl_product_added_successfully') });
          } else {
            this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: this.cs.getLabel('product.lbl_product_updated_successfully') });
          }

          setTimeout(() => {
            this.router.navigate(["app/orders?status=all"]);
          }, 500);
        },
        error: () => {
          if (isNew) {
            this.cs.onDisplayMessage(this.data, 'product', AppSettings.MSG_ACTION.ADD, 'error');
          } else {
            this.cs.onDisplayMessage(this.data, 'product', AppSettings.MSG_ACTION.UPDATE, 'error');
          }
        }
      });
  }

  onPreviousClick() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }

  onNextBtnClick() {
    if (this.miFormComponent) {
      //   this.miFormComponent.onSubmit();
    }
  }

  onNextClick() {
    if (this.activeIndex < this.getLastIndex()) {
      this.activeIndex++;
    }
  }

  getLastIndex(): number {
    return this.orderAttributeData?.tabs?.length - 1;
  }

  isLastIndex(): boolean {
    return this.activeIndex === this.getLastIndex();
  }

  onCancel() {
    this.redirectToListPage();
  }

  redirectToListPage() {
    this.router.navigate(["app/orders"]);
  }

  openPatientDialog(index: number) {
    if (!this.isPatientManagmentOn) {
      return;
    }
    this.selectedProductIndex = index;
    this.selectedPatientsForDialog = this.products[index]?.selectedPatients ? [...this.products[index].selectedPatients] : [];
    this.showPatientDialog = false;
    setTimeout(() => {
      this.showPatientDialog = true;
    });
  }

  onPatientSelectionSave(event: { index: number, patients: any[] }) {
    if (this.products[event.index]) {
      this.products[event.index].patient_ids = event.patients.map(p => p.id);
      this.products[event.index].selectedPatients = event.patients;
    }
  }

  onQuantityKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
      return;
    }

    const target = event.target as HTMLInputElement;
    const currentValue = target.value;
    const newValue = currentValue + event.key;

    if (newValue.length > 6) {
      event.preventDefault();
      return;
    }

    const numericValue = parseInt(newValue);
    if (numericValue > 999999) {
      event.preventDefault();
    }
  }

  onQuantityInput(event: Event, productIndex: number) {
    const target = event.target as HTMLInputElement;
    let value = target.value;

    value = value.replace(/[^0-9]/g, '');

    if (value.length > 6) {
      value = value.substring(0, 6);
    }

    const numericValue = parseInt(value) || 0;
    if (numericValue > 999999) {
      value = '999999';
    }

    if (this.products[productIndex]) {
      this.products[productIndex].qty = parseInt(value) || 0;
      this.validateQuantity(productIndex, parseInt(value) || 0);
    }
  }

  validateQuantity(productIndex: number, value: number): void {
    if (value < 0) {
      this.quantityErrors[productIndex] = 'Quantity cannot be negative';
    } else if (value > 999999) {
      this.quantityErrors[productIndex] = 'Quantity cannot exceed 999,999';
    } else if (value === 0) {
      this.quantityErrors[productIndex] = 'Quantity must be greater than 0';
    } else {
      delete this.quantityErrors[productIndex];
    }
  }

  clearQuantityError(productIndex: number): void {
    delete this.quantityErrors[productIndex];
  }

  getTotalQuantity(): number {
    return this.confirmProducts.reduce((total, product) => {
      return total + (parseInt(product.qty) || 0);
    }, 0);
  }
}

